import { useState, useEffect } from "react";
import { buscarPeriodoUsuarioByIdService } from "../../../services/buscarPeriodoUsuarioByIdService";
import { buscarInteresseByIdService } from "../../../services/buscarInteresseByIdService";

export const useBuscarInt = (interesseId: number, isModalOpen: boolean) => {
  const [int, setInt] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      if (!isModalOpen || !interesseId) {
        setIsLoading(false);
        return;
      }
      setIsLoading(true);
      try {
        const data = await buscarInteresseByIdService(interesseId);
        setInt(data);
      } catch (error) {
        console.error("Erro ao buscar interesse:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetch();
  }, [isModalOpen, interesseId]);

  return { int, isLoading };
};
